export default import.meta.ROLLDOWN_FILE_URL_kzw3Kopv1hLF2EnYY1oE$g